package provider

import androidx.compose.material3.*
import androidx.compose.runtime.*
import compose.assets.*
import compose.assets.svg.*
import kotlinx.coroutines.*

@Suppress("unused")
val LocalHomeDrawerProvider =
    staticCompositionLocalOf<HomeDrawerProvider> { error("HomeDriverProvider is not implemented by CompositionLocalProvider") }

class HomeDrawerProvider(
    private val scope: CoroutineScope,
    val state: DrawerState?
) {

    val isEnabled: Boolean get() = state != null

    val isClosed: Boolean get() = state?.isClosed == true

    fun open() {
        scope.launch {
            state?.open()
        }
    }

    fun close() {
        scope.launch {
            state?.close()
        }
    }

    @Composable
    fun MenuIcon(alternative: @Composable () -> Unit = {}) {
        if (isEnabled) {
            IconButton({ open() }) {
                Icon(Svg.Menu, null)
            }
        } else {
            alternative()
        }
    }

    companion object {
        @Composable
        fun remember(): HomeDrawerProvider {
            val state = rememberDrawerState(initialValue = DrawerValue.Closed)
            val display = LocalDisplayProvider.current
            val scope = rememberCoroutineScope()
            return remember {
                HomeDrawerProvider(
                    scope = scope,

                    if (display.isMobile) state
                    else null
                )
            }
        }
    }
}
